"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var simple_notifications_component_1 = require("./simple-notifications/components/simple-notifications.component");
var notification_component_1 = require("./simple-notifications/components/notification.component");
var max_pipe_1 = require("./simple-notifications/pipes/max.pipe");
var notifications_service_1 = require("./simple-notifications/services/notifications.service");
__export(require("./simple-notifications/interfaces/icons"));
__export(require("./simple-notifications/components/simple-notifications.component"));
__export(require("./simple-notifications/components/notification.component"));
__export(require("./simple-notifications/pipes/max.pipe"));
__export(require("./simple-notifications/services/notifications.service"));
var SimpleNotificationsModule = (function () {
    function SimpleNotificationsModule() {
    }
    SimpleNotificationsModule.forRoot = function () {
        return {
            ngModule: SimpleNotificationsModule,
        };
    };
    return SimpleNotificationsModule;
}());
SimpleNotificationsModule.decorators = [
    { type: core_1.NgModule, args: [{
                providers: [notifications_service_1.NotificationsService],
                imports: [
                    common_1.CommonModule
                ],
                declarations: [
                    simple_notifications_component_1.SimpleNotificationsComponent,
                    notification_component_1.NotificationComponent,
                    max_pipe_1.MaxPipe
                ],
                exports: [simple_notifications_component_1.SimpleNotificationsComponent]
            },] },
];
/** @nocollapse */
SimpleNotificationsModule.ctorParameters = function () { return []; };
exports.SimpleNotificationsModule = SimpleNotificationsModule;
//# sourceMappingURL=simple-notifications.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/angular2-notifications/dist/src/simple-notifications.module.js
// module id = ../../../../angular2-notifications/dist/src/simple-notifications.module.js
// module chunks = 5